"use client";

import { Mail, Phone, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const contactItems = [{
  id: 1,
  icon: "mail",
  label: "Email Ufficiale",
  value: "info@worldimmigration.it",
  href: "mailto:info@worldimmigration.it"
}, {
  id: 2,
  icon: "telegram",
  label: "Consulenza Rapida",
  value: "Invia un Messaggio",
  href: "/ContactsPage"
}, {
  id: 3,
  icon: "phone",
  label: "Telefono",
  value: "+39 049 86 40 662",
  href: "tel:+390498640662"
}];
function ContactIcon({
  type
}: {
  type: string;
}) {
  const iconClass = "w-7 h-7";
  const iconColor = "var(--primary)";
  if (type === "mail") {
    return <Mail className={iconClass} style={{
      color: iconColor
    }} strokeWidth={2} />;
  }
  if (type === "telegram") {
    return <Send className={iconClass} style={{
      color: iconColor
    }} strokeWidth={2} />;
  }
  if (type === "phone") {
    return <Phone className={iconClass} style={{
      color: iconColor
    }} strokeWidth={2} />;
  }
  return null;
}
export default function ContactOurExpertTeam() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.15
  });
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: btnRef,
    isVisible: btnVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="231812" id="contactcta" ref={sectionRef} className="bg-background text-foreground py-24 px-6">
      <div className="max-w-6xl mx-auto">
        {}
        <div className={`text-center mb-16 transition-all duration-700 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="font-default text-xs font-bold tracking-widest uppercase mb-4" style={{
          color: "var(--primary)",
          letterSpacing: "0.1em"
        }}>
            CONTATTACI
          </p>
          <h2 className="font-default text-5xl font-bold mb-5" style={{
          color: "var(--foreground)"
        }}>
            Consulenza Professionale
          </h2>
          <p className="font-default text-xl font-normal max-w-2xl mx-auto" style={{
          color: "var(--muted-foreground)",
          lineHeight: 1.6
        }}>
            Per una consulenza specifica, contatta lo Studio World Immigration. Il nostro team di esperti è a tua completa disposizione.
          </p>
        </div>

        {}
        <div ref={cardsRef} className={`grid grid-cols-1 md:grid-cols-3 gap-6 mb-12 transition-all duration-700 delay-200 ${cardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {contactItems.map((item, i) => <div data-index={i} key={item.id}>
              <Card className="shadow-lg border border-border rounded-md py-0 bg-card">
                <CardContent className="flex flex-col items-center text-center p-8 gap-4">
                  {}
                  <div className="flex items-center justify-center w-16 h-16 rounded-md" style={{
                backgroundColor: "var(--accent)"
              }}>
                    <ContactIcon type={item.icon} />
                  </div>
                  {}
                  <h3 className="font-default text-xl font-bold" style={{
                color: "var(--foreground)"
              }}>
                    {item.label}
                  </h3>
                  {}
                  <Link to={item.href} newTab={item.href.startsWith('http') || item.href.startsWith('mailto') || item.href.startsWith('tel')} className="font-default text-base font-medium hover:text-primary transition-colors" style={{
                color: "var(--muted-foreground)"
              }}>
                    {item.value}
                  </Link>
                </CardContent>
              </Card>
            </div>)}
        </div>

        {}
        <div ref={btnRef} className={`flex justify-center transition-all duration-700 delay-400 ${btnVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Button asChild className="bg-[#FFC829] text-primary hover:bg-[#FFC829]/90 rounded-md px-10 py-7 text-lg font-semibold shadow-md transition-transform hover:scale-105">
            <Link to="/ContactsPage">
              <Send className="w-5 h-5" />
              Invia Richiesta
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}